import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import { TextField, Box, Typography, Chip, IconButton, InputAdornment, Stack, Button, } from '@mui/material';
import { AddRounded as AddRoundedIcon, DeleteOutlineRounded as DeleteOutlineRoundedIcon, } from '@mui/icons-material';
export const StringListEditor = ({ label, items, onChange, placeholder = 'Add an item and press Enter', emptyHint, variant = 'chips', }) => {
    const [draft, setDraft] = useState('');
    const addItem = () => {
        const trimmed = draft.trim();
        if (!trimmed)
            return;
        if (items.includes(trimmed)) {
            setDraft('');
            return;
        }
        onChange([...items, trimmed]);
        setDraft('');
    };
    const removeAt = (index) => onChange(items.filter((_, i) => i !== index));
    const inputCommon = {
        placeholder,
        size: 'small',
        fullWidth: true,
        value: draft,
        onChange: (e) => setDraft(e.target.value),
        onKeyDown: (e) => {
            if (e.key === 'Enter') {
                e.preventDefault();
                addItem();
            }
        },
    };
    return (_jsxs(Box, { children: [_jsx(Typography, { variant: "subtitle2", color: "text.secondary", sx: { mb: 1 }, children: label }), variant === 'chips' ? (_jsxs(_Fragment, { children: [_jsxs(Box, { sx: { display: 'flex', flexWrap: 'wrap', gap: 1, mb: 1.5 }, children: [items.map((item, index) => (_jsx(Chip, { label: item, size: "small", color: "primary", variant: "outlined", onDelete: () => removeAt(index) }, `${item}-${index}`))), items.length === 0 && emptyHint && (_jsx(Typography, { variant: "body2", color: "text.disabled", sx: { fontStyle: 'italic' }, children: emptyHint }))] }), _jsx(TextField, { ...inputCommon, InputProps: {
                            endAdornment: (_jsx(InputAdornment, { position: "end", children: _jsx(Button, { size: "small", onClick: addItem, disabled: !draft.trim(), sx: { textTransform: 'none', minWidth: 'auto' }, children: "Add" }) })),
                        } })] })) : (_jsxs(_Fragment, { children: [items.length > 0 && (_jsx(Stack, { spacing: 0.75, sx: { mb: 1.25 }, children: items.map((item, index) => (_jsxs(Box, { sx: {
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1,
                                px: 1.25,
                                py: 0.75,
                                borderRadius: 1.5,
                                bgcolor: 'action.hover',
                            }, children: [_jsx(Typography, { variant: "body2", sx: { flex: 1, lineHeight: 1.4 }, children: item }), _jsx(IconButton, { size: "small", onClick: () => removeAt(index), "aria-label": `Remove: ${item}`, children: _jsx(DeleteOutlineRoundedIcon, { fontSize: "small" }) })] }, `${item}-${index}`))) })), _jsxs(Stack, { direction: "row", spacing: 1, alignItems: "stretch", children: [_jsx(TextField, { ...inputCommon }), _jsx(Button, { variant: "outlined", size: "small", onClick: addItem, disabled: !draft.trim(), startIcon: _jsx(AddRoundedIcon, {}), sx: { flexShrink: 0 }, children: "Add" })] })] }))] }));
};
